import { BankDetailsEndPoint } from '@/modules/common/enums/end-point.ts';
import Api from '@/modules/core/api/api.ts';
import { unref } from 'vue';
import { TableId } from '@/modules/common/enums/table-id.enum.ts';
import type { BankCBRF } from '@/modules/common/adapters/bank-cbrf.type.ts';
import type { SourcedOption } from '@/modules/common/types/option.type.ts';

export interface BankDetailsFormData {
  bank: SourcedOption<BankCBRF>;
  bankIdentificationCode: string;
  correspondentAccount: string;
  currentAccount: string;
  comment: string;
}

interface AddRequest {
  parentId: number;
  formData: BankDetailsFormData;
}

interface EditRequest extends AddRequest {
  id: number;
}

export default class BankDetailsApi {
  static async add({ parentId, formData }: AddRequest) {
    const data = unref(formData);

    await Api.post(BankDetailsEndPoint.Add, {
      parent_table_id: TableId.Counterparties,
      parent_id: parentId,
      bank_name: data.bank.source.name,
      bik: data.bankIdentificationCode,
      kc: data.correspondentAccount,
      account: data.currentAccount,
      comment: data.comment || undefined,
    });
  }

  static async edit({ parentId, id, formData }: EditRequest) {
    const data = unref(formData);

    await Api.post(BankDetailsEndPoint.Edit, {
      parent_table_id: TableId.Counterparties,
      parent_id: parentId,
      account_id: id,
      bank_name: data.bank.source.name,
      bik: data.bankIdentificationCode,
      kc: data.correspondentAccount,
      account: data.currentAccount,
      comment: data.comment || undefined,
    });
  }

  static async delete(id: number) {
    await Api.post(BankDetailsEndPoint.Delete, { account_id: id });
  }
}
